export interface RawThread {
  id: string
  title: string
  username: string
  last_updated_time: string
}

export interface Thread extends Omit<RawThread, 'last_updated_time'> {
  lastUpdatedTime: Date
}

export function transformThread(raw: RawThread): Thread {
  return {
    id: raw.id,
    title: raw.title,
    username: raw.username,
    lastUpdatedTime: new Date(raw.last_updated_time),
  }
}

export function transformThreads(raws: RawThread[]) {
  return raws.map(transformThread)
}
